'use client';

import { useEffect } from 'react';

export const ClarityConsent: React.FC = () => {
  useEffect(() => {
    const handleClarityConsent = (hasAnalyticsConsent: boolean) => {
      if (typeof window.clarity === 'function') {
        window.clarity('consentv2', {
          ad_storage: hasAnalyticsConsent ? 'granted' : 'denied',
          analytics_storage: hasAnalyticsConsent ? 'granted' : 'denied',
        });
      }
    };

    const handleAcceptAll = () => handleClarityConsent(true);
    const handleAccept = () => handleClarityConsent(true);
    const handleReject = () => handleClarityConsent(false);
    const handlePerformanceCategory = () => handleClarityConsent(true);

    // Listen for CookieScript events
    window.addEventListener('CookieScriptAcceptAll', handleAcceptAll);
    window.addEventListener('CookieScriptAccept', handleAccept);
    window.addEventListener('CookieScriptReject', handleReject);
    window.addEventListener('CookieScriptCategory-performance', handlePerformanceCategory);

    // Cleanup function
    return () => {
      window.removeEventListener('CookieScriptAcceptAll', handleAcceptAll);
      window.removeEventListener('CookieScriptAccept', handleAccept);
      window.removeEventListener('CookieScriptReject', handleReject);
      window.removeEventListener('CookieScriptCategory-performance', handlePerformanceCategory);
    };
  }, []);

  return null;
};
